export default {
  // GET Requests //

  // Gets all reward data
  async getRewardsData(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let rewards;
    let claims;
    try {
      rewards = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/rewards/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      rewards = await rewards.json();

      claims = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/reward-claims/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      claims = await claims.json();
    } catch (err) {
      return 500;
    }

    for (let i = 0; i < rewards.rewards.length; i++) {
      rewards.rewards[i].rewardId = rewards.rewards[i]._id;
    }
    context.commit("rewards", rewards.rewards);

    let pendingClaims = 0;
    claims.rewardClaims.forEach((claim) => {
      if (!claim.approvalDate) {
        pendingClaims = pendingClaims + 1;
      }
    });
    context.commit("claims", claims.rewardClaims);
    context.commit("pendingClaims", pendingClaims);
    context.commit("rewardsTimestamp");

    return 200;
  },
  // POST Requests //

  // Create a reward
  async postReward(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(process.env.VUE_APP_NODE_SERVER + "/rewards/add", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          title: payload.title,
          type: payload.type,
          description: payload.description,
          conditions: payload.conditions,
          audience: payload.audience,
          departments: payload.departments,
          locations: payload.locations,
          points: payload.points,
        }),
      });
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    var rewardsPayload = context.state.rewards;
    response.reward.rewardId = response.reward._id;
    rewardsPayload.push(response.reward);

    context.commit("rewards", rewardsPayload);

    return {
      status: 201,
      rewardId: response.reward.rewardId,
    };
  },
  // PATCH Requests //

  // Update a reward
  async patchReward(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/rewards/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            rewardId: payload.rewardId,
            companyId: companyId,
            title: payload.title,
            description: payload.description,
            conditions: payload.conditions,
            audience: payload.audience,
            departments: payload.departments,
            locations: payload.locations,
            points: payload.points,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    response.reward.rewardId = response.reward._id;
    var rewardsPayload = context.state.rewards;
    for (let i = 0; i < rewardsPayload.length; i++) {
      if (rewardsPayload[i].rewardId == response.reward.rewardId) {
        rewardsPayload[i] = response.reward;
        break;
      }
    }

    context.commit("rewards", rewardsPayload);

    return 200;
  },
  // Update a reward
  async patchRewardClaim(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/reward-claims/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            rewardClaimId: payload.rewardClaimId,
            companyId: companyId,
            approvalDate: payload.approvalDate,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var claimsPayload = context.state.claims;
    for (let i = 0; i < claimsPayload.length; i++) {
      if (claimsPayload[i].rewardClaimId == response.rewardClaimId) {
        claimsPayload[i].approvalDate = response.approvalDate;
        break;
      }
    }

    context.commit("claims", claimsPayload);

    if (payload.approvalDate) {
      context.commit(
        "pendingClaims",
        context.state.pendingClaims != 0
          ? context.state.pendingClaims - 1
          : context.state.pendingClaims
      );
    }

    return 200;
  },
  // Adds reward image
  async patchRewardImage(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fd = new FormData();
    fd.append("file", payload.file, payload.rewardId);
    fd.append("rewardId", payload.rewardId);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/rewards/update-reward-image",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }

    session.reward.rewardId = session.reward._id;

    let rewardsPayload = context.state.rewards;
    for (let i = 0; i < rewardsPayload.length; i++) {
      if (rewardsPayload[i].rewardId == session.reward.rewardId) {
        rewardsPayload[i] = session.reward;
        break;
      }
    }

    context.commit("rewards", rewardsPayload);

    session.status = 200;
    return session;
  },
  // DELETE Requests //

  // Delete reward
  async deleteReward(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/rewards/remove",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            rewardId: payload.rewardId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var rewardsPayload = context.state.rewards.filter(
      (rew) => rew.rewardId != response.rewardId
    );

    context.commit("rewards", rewardsPayload);

    return 201;
  },
  // Reset
  rewardsTimestampReset(context) {
    context.commit("rewardsTimestampReset");
  },
};
